module.exports = __webpack_public_path__ + "img/yellowPark.80845102.svg";